import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, DATE, formatErr } from "@/lib/api";
import DataTable, { EmptyState } from "@/components/app/DataTable";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => {
    try { const { data } = await api.get("/audit-logs?limit=300"); setRows(data); }
    catch (e) { toast.error(formatErr(e)); }
    finally { setLoading(false); }
  })(); }, []);
  return (
    <div className="space-y-6">
      <div>
        <span className="gc-label">Administrasi</span>
        <h1 className="gc-h1 mt-1">Audit Log</h1>
        <p className="mt-2 text-slate-500">Catatan seluruh aktivitas penting sistem — untuk transparansi dan audit hilirisasi.</p>
      </div>
      {loading ? <div className="gc-card"><Loader2 className="w-4 h-4 animate-spin" /></div> : (
        <DataTable
          rows={rows}
          columns={[
            { key: "created_at", header: "Waktu", render: (r) => DATE(r.created_at) },
            { key: "actor_email", header: "Pengguna" },
            { key: "action", header: "Aksi", render: (r) => <span className="font-mono text-xs text-emerald-700">{r.action}</span> },
            { key: "entity", header: "Entitas" },
            { key: "entity_id", header: "ID", render: (r) => r.entity_id ? <span className="font-mono text-[10px] text-slate-400">{r.entity_id.slice(0, 8)}</span> : "-" },
          ]}
          empty={<EmptyState title="Belum ada log" desc="Aktivitas sistem akan muncul di sini." />}
        />
      )}
    </div>
  );
}
